import {GhostButton} from "@bolteu/clay-react";
import styled from "styled-components";

export const Background = styled.div`
    width: 100%;
`;

export const Footer = styled.div`
    max-width: 500px;
    margin: 40px auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const SloganWrapper = styled.div`
    margin-bottom: 16px;
`;

export const SocialMediaButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    width: 104px;
    gap: 16px;
`;

export const SocialMediaButton = styled(GhostButton)`
    height: 24px;
    width: 24px;
    min-width: 24px;
    padding: 0;
`;
